export const environment = {
  // Browser error reporting (src/app/sentry.ts) — the frontend Sentry project,
  // events tagged `surface: landing`. The DSN is a public, ingest-only key.
  sentry: {
    enabled: true,
    dsn: 'https://af95080852ca490e9b42b14560f8d0a8@o4505181402234880.ingest.us.sentry.io/4505182700306432',
    environment: 'landing-production',
  },
  // Session recording (src/app/openreplay.ts) — self-hosted OpenReplay, the same
  // project as app.uptal.com so a cv_code search shows the whole journey.
  openReplay: {
    enabled: true,
    projectKey: 'Q7Uq5tmAwm3h9hmqcDy0',
    ingestPoint: 'https://replay.uptal.com/ingest',
  },
  production: true,
  apiUrl: 'https://api.uptal.com/',
  appUrl: 'https://app.uptal.com',
  moyasarPublishableKey: 'pk_live_QZ9epQXHAhX1xcUmyTkJ2AQqnx4fBmMnqj4rBX9Q',
  server: 'prod',
  geolocation: 'https://api.db-ip.com/v2/free/self',
  google_analytics_tag: 'G-WCHTRS9GNK',
  airtable_api_url:
    'https://api.airtable.com/v0/appM2DL34VxsUSC7Y/Website Email Submit',
  airtable_api_key:
    'patIlHC0H4Yu778aT.015c0c3f8f4ff99b4c0c563e3702513e70a271ac97a068666d363596fc9a9244', // Note: Don't expose this in production! @metwaly please help hide this
  referral: {
    firstPromoter: {
      enabled: true,
      accountId: 'cf29jzs8',
      scriptUrl: 'https://cdn.firstpromoter.com/fpr.js',
    },
  },
  cleverTap: {
    enabled: true,
    // Project ID (Account ID) + Project Token from the CleverTap dashboard.
    // The PASSCODE is the server-side credential and must never appear here.
    // No region key: the account is on CleverTap's default ("global"/EU)
    // cluster, whose SDK configuration is the absence of a region.
    accountId: 'RK4-879-487Z',
    token: 'cab-432',
    debug: false,
  },
};
